import { gql } from 'urql';
import { PRODUCT } from '../client';
import { ROUTE_FRAGMENT } from './fragments';

export const UNMARK_ROUTE_PROVIDER = gql`
  ${ROUTE_FRAGMENT}
  mutation ${PRODUCT}UnmarkRouteProvider($input: UnmarkRouteProviderInput!) {
    unmarkRouteProvider(input: $input) {
      route {
        ...RouteFragment
      }
      userErrors {
        __typename
        ... on UserErrorInterface {
          message
        }
      }
    }
  }
`;
